var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFrame(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114,
    height: 54,
    viewBox: "0 0 114 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M0 54H4V27.6582C4 27.106 3.55228 26.6582 3 26.6582H1C0.447715 26.6582 0 27.106 0 27.6582V54Z",
    fill: "#EBEAED"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 54H4V49.8572C4 49.3049 3.55228 48.8572 3 48.8572H1C0.447715 48.8572 0 49.3049 0 49.8572V54Z",
    fill: "#EBEAED"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M10 54H14V16.7649C14 16.2126 13.5523 15.7649 13 15.7649H11C10.4477 15.7649 10 16.2126 10 16.7649V54Z",
    fill: "#EBEAED"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10 54H14V51.5714C14 51.0191 13.5523 50.5714 13 50.5714H11C10.4477 50.5714 10 51.0191 10 51.5714V54Z",
    fill: "#EBEAED"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M20 54H24V1.87885C24 1.32656 23.5523 0.878845 23 0.878845H21C20.4477 0.878845 20 1.32656 20 1.87885V54Z",
    fill: "#EBEAED"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20 54H24V44.7143C24 44.162 23.5523 43.7143 23 43.7143H21C20.4477 43.7143 20 44.162 20 44.7143V54Z",
    fill: "#EBEAED"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M30 54H34V7.3472C34 6.79491 33.5523 6.3472 33 6.3472H31C30.4477 6.3472 30 6.79491 30 7.3472V54Z",
    fill: "#EBEAED"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M30 54H34V29.2857C34 28.7334 33.5523 28.2857 33 28.2857H31C30.4477 28.2857 30 28.7334 30 29.2857V54Z",
    fill: "#EBEAED"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M40 54H44V3.48463C44 2.93235 43.5523 2.48463 43 2.48463H41C40.4477 2.48463 40 2.93235 40 3.48463V54Z",
    fill: "#EBEAED"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M40 54H44V26.7143C44 26.162 43.5523 25.7143 43 25.7143H41C40.4477 25.7143 40 26.162 40 26.7143V54Z",
    fill: "#EBEAED"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M50 54H54V9.73418C54 9.18189 53.5523 8.73418 53 8.73418H51C50.4477 8.73418 50 9.18189 50 9.73418V54Z",
    fill: "#EBEAED"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M50 54H54V47.2857C54 46.7334 53.5523 46.2857 53 46.2857H51C50.4477 46.2857 50 46.7334 50 47.2857V54Z",
    fill: "#EBEAED"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M60 54H64V7.3472C64 6.79491 63.5523 6.3472 63 6.3472H61C60.4477 6.3472 60 6.79491 60 7.3472V54Z",
    fill: "#EBEAED"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M60 54H64V37C64 36.4477 63.5523 36 63 36H61C60.4477 36 60 36.4477 60 37V54Z",
    fill: "#EBEAED"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M70 54H74V19.0651C74 18.5128 73.5523 18.0651 73 18.0651H71C70.4477 18.0651 70 18.5128 70 19.0651V54Z",
    fill: "#EBEAED"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M70 54H74V40.4286C74 39.8763 73.5523 39.4286 73 39.4286H71C70.4477 39.4286 70 39.8763 70 40.4286V54Z",
    fill: "#EBEAED"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M80 53.859H84V14.2369C84 13.6846 83.5523 13.2369 83 13.2369H81C80.4477 13.2369 80 13.6846 80 14.2369V53.859Z",
    fill: "#EBEAED"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M80 54H84V32.7143C84 32.162 83.5523 31.7143 83 31.7143H81C80.4477 31.7143 80 32.162 80 32.7143V54Z",
    fill: "#EBEAED"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M90 54H94V1.00002C94 0.447731 93.5523 1.52588e-05 93 1.52588e-05H91C90.4477 1.52588e-05 90 0.447731 90 1.00002V54Z",
    fill: "#EBEAED"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M90 54H94V42.1092C94 41.5569 93.5523 41.1092 93 41.1092H91C90.4477 41.1092 90 41.5569 90 42.1092V54Z",
    fill: "#EBEAED"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M100 54H104V1.85715C104 1.30486 103.552 0.857143 103 0.857143H101C100.448 0.857143 100 1.30486 100 1.85714V54Z",
    fill: "#EBEAED"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M100 54H104V47.2857C104 46.7334 103.552 46.2857 103 46.2857H101C100.448 46.2857 100 46.7334 100 47.2857V54Z",
    fill: "#EBEAED"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M110 54H114V15.9403C114 15.388 113.552 14.9403 113 14.9403H111C110.448 14.9403 110 15.388 110 15.9403V54Z",
    fill: "#EBEAED"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M110 54H114V42.1429C114 41.5906 113.552 41.1429 113 41.1429H111C110.448 41.1429 110 41.5906 110 42.1429V54Z",
    fill: "#EBEAED"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame);
export default __webpack_public_path__ + "static/media/frame.a70d847d627bc91fa34e888aa26ba5dc.svg";
export { ForwardRef as ReactComponent };